export default "__VITE_ASSET__vUV5w9Kn__"